export enum PeriodUnitType {
  NoExpiration = 'no_expiration',
  Months = 'months',
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes'
}

export interface ConsumptionSheetExpirationERPSettings {
  amount?: number
  periodUnit?: PeriodUnitType
}

export interface ConsumptionSheetERPSettings {
  isEnabled: boolean
  expirationSettings?: ConsumptionSheetExpirationERPSettings
}
